export default "__VITE_ASSET__Bd8wJ12j__"